var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDroogButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "droog-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 334.635,
    height: 331.563,
    viewBox: "0 0 334.635 331.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M65.7,284.415A156.812,156.812,0,1,1,268.935,47.149,156.811,156.811,0,1,1,65.7,284.415Z",
    transform: "translate(0.15 0.92)",
    fill: "#0d2f55"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-0.15 -0.92)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0.105 0.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-26.717 -49.872)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 156.828,
    cy: 156.793,
    rx: 156.828,
    ry: 156.793,
    transform: "translate(47.741 68.639)",
    fill: "#0d2f55"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 156.828,
    cy: 156.793,
    rx: 156.828,
    ry: 156.793,
    transform: "translate(26.762 50.661)",
    fill: "#174374"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 471.776,
    transform: "matrix(-0.626, -0.78, 0.78, -0.626, 339.339, 373.631)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 414.456,
    transform: "matrix(0.922, -0.386, 0.386, 0.922, 3.523, 270.782)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 231.25,
    transform: "matrix(0.142, -0.99, 0.99, 0.142, 86.771, 451.752)",
    fill: "none",
    stroke: "#f9f9f9",
    strokeWidth: 18
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroogButton);
export default __webpack_public_path__ + "static/media/droog-button.4deacb48466703050b19a05aa62416da.svg";
export { ForwardRef as ReactComponent };